export enum MasterDataType {
    Contact = 'contact',
    Product = 'product'
}